import React from 'react'

import { StatisticsFeaturedJournalBarChart } from './statistics-featured-journal-bar-chart.component'
import { StatisticsFeaturedJournalLineChart } from './statistics-featured-journal-line-chart.component'

export const StatisticsFeaturedJournal = () => {
  return (
    <div>
      <StatisticsFeaturedJournalBarChart />
      <StatisticsFeaturedJournalLineChart />
    </div>
  )
}
